<template>
  <div class="el-textarea">
    <vue-tribute :options="{...tributeOptions}">
                <textarea
                  type="textarea"
                  class="el-textarea__inner"
                  data-tribute="true"
                  ref="gg"
                  @blur="blur"
                >
                </textarea>
    </vue-tribute>
  </div>
</template>

<script>
import VueTribute from 'vue-tribute'

export default {
  name: "Comments",
  props: ['value', 'allUsers', 'user', 'form'],
  watch: {
    value() {
      this.inpValue = this.value
    }
  },
  components: {VueTribute},
  data() {
    return {
      inpValue: '',
      tributeOptions: {
        trigger: '@',
        noMatchTemplate: () => '<li>Пользователь не найден</li>',
        values: (text, cb) => this.getNames(text, cb)
      }
    }
  },
  methods: {
    blur() {
      this.$emit('input', this.$refs.gg.value)
    },
    clearValue() {
      this.$refs.gg.value = ''
    },
    getNames(t, sb) {
      const users = this.allUsers;

      const result = []
      const user = this.form.user || {}
      const reporter = this.form.executor || {}


      users.forEach(({label, value, email}) => {
        if (this.form.notifications.find((u) => u.value === value) || (user.uid || user.id) === value || (reporter.uid || reporter.id) === value) {
          result.push({
            value: label,
            key: label,
            email
          })
        }
      })

      sb([
        {key: 'Все', value: 'Все'},
        ...result
      ])
    },
  }
}
</script>



// WEBPACK FOOTER //
// src/views/Dashboard/Tasks/Comments.vue